/**
 * Show a success notification.
 */
export const notifySuccess = (title: string, description?: string): void => {
  useToast().add({
    color: 'success',
    icon: 'i-heroicons-check-circle',
    title,
    description,
  });
};

/**
 * Show an error notification.
 */
export const notifyError = (title: string, description?: string): void => {
  useToast().add({
    color: 'error',
    icon: 'i-heroicons-x-circle',
    title,
    description,
  });
};
